<template>
  <div class="custom">
      <img src="../assets/img/index/weiimg.jpg" alt="">
      <p class="peowei">管家微信：yunzhitugj</p>
      <p class="phone">联系电话：022-25636070</p>
      <p class="email">管家邮箱：gj@yunzhitupingtai.com</p>
  </div>
</template>

<script>
import bus from '../utiles/bus'
import Vue from 'vue' 
export default {
  name: 'custom',
  data () {
    return {
    }
  },
  mounted(){
    // this.listenPage()
    this.STATE.state.bottomindex='btnFour'
  },
  methods: {
    // listenPage() {
    //   window.onbeforeunload = function (e) {
    //     console.log('1234444444')
    //     bus.$emit('routerBus', 'btnFour')
    //   };
    // },
  }
}
</script>

<style scoped>
.custom{
    text-align:center;
    color:#333;
}
.custom img{
    width:50%;
    height:auto;
    margin-top:133px;
}
.custom .peowei{

}
.custom .phone{
    margin-top: 23px;
}
.custom .email{
    margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// custom.vue?e944fe54